import { default as aboutoaqsOLaDR5Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsNhLwZNvikEMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93iSEPYRt8TnMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samplew2CZcm1hUdMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsUHVBE1RDQJMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93in9TWbwDRQMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewTW6CMexVdoMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexhaX5UufEUsMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93D7PuYnRycmMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexei9Tw75l6hMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93NIlM9NeVxeMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexhEziq7fLr0Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessions59AaQ20P1jMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsPUTLCFEU81Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviews6HRbzb71aIMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93PtLHj8p1XXMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexg1Y8aH9PuSMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmYrTdU3cpuNMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmoTSghRia5EMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendarA6MXLehnsRMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatAsLRQpXroNMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutCJaNPWXsz1Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedbVKQ5MwjV2Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as memberskbLFzNw0X0Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93ZFG1Qt8OG9Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editHQpiTco3AnMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_939afb72Lb8dMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communitygS5lz6Ot6RMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_931oDdbcjk2oMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_937tuQR6jzx8Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardnjagcio01FMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexmai1kWu4eJMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutJbUyiao4LCMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productzx86FhBeGoMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as events3hL2MadiOtMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93RNf9cruDbRMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexCt7lwsFixBMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93CJSNgVsMl8Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93jHVJRgPTuRMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexfjL8mtvdtxMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93yuzIVc3Dv5Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joinS56979vcSEMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/join.vue?macro=true";
import { default as loginpavzGGn8QtMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/login.vue?macro=true";
import { default as logoutQjqeolaskMMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93S4AQtSjIj2Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93qqNIY1laGlMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93feQKDfwAdbMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritesMBJGhFVGGQMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studioslGnlSkOp89Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optinSnrO9npU0FMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93srktvtmQsxMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexTXFlIxJ3z0Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as indexdCGjrBCGImMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as aboutnd3OxzOXM7Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45content7k6XXyiowRMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventsSFd9RUvdrCMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93h5aRYzxtDqMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleKEWsEF8pt8Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsCSVXxvVHAqMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93JiAjxQMegHMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as view2mftcnPqczMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexgQYCSRRFlvMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93sQXGljHVVsMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexUGh8LkVziPMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_930ZaYMrX34DMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexIcUkSj0v76Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsHnCpSnWkrNMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordings3kCq0S3LmUMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviews8UioZpvnvKMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93q58ssjBRktMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexSYGbTfmfq9Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexKPgeOMVDS8Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesySrdx84TG9Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionszEypn95vAhMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93u1FfGtOJjzMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93ey6SdqgybsMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as reset5SwQMMVUGcMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/reset.vue?macro=true";
import { default as shopWs1cHNNRBVMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/shop.vue?macro=true";
import { default as signupah9zGhp6XpMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/signup.vue?macro=true";
import { default as liveRn7aMKLqREMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsjVWhOpaDuPMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93NetqkK5zd2Meta } from "/tmp/build_3027f3f6/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compact0F26Z4QgksMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as fulllUvYc5kRCWMeta } from "/tmp/build_3027f3f6/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93PtLHj8p1XXMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93PtLHj8p1XXMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93PtLHj8p1XXMeta || {},
    alias: _91product_id_93PtLHj8p1XXMeta?.alias || [],
    redirect: _91product_id_93PtLHj8p1XXMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutoaqsOLaDR5Meta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutoaqsOLaDR5Meta?.path ?? "about",
    meta: aboutoaqsOLaDR5Meta || {},
    alias: aboutoaqsOLaDR5Meta?.alias || [],
    redirect: aboutoaqsOLaDR5Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsNhLwZNvikEMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsNhLwZNvikEMeta?.path ?? "events",
    meta: eventsNhLwZNvikEMeta || {},
    alias: eventsNhLwZNvikEMeta?.alias || [],
    redirect: eventsNhLwZNvikEMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93iSEPYRt8TnMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93iSEPYRt8TnMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93iSEPYRt8TnMeta || {},
    alias: _91media_id_93iSEPYRt8TnMeta?.alias || [],
    redirect: _91media_id_93iSEPYRt8TnMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samplew2CZcm1hUdMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45samplew2CZcm1hUdMeta?.path ?? "free-sample",
    meta: free_45samplew2CZcm1hUdMeta || {},
    alias: free_45samplew2CZcm1hUdMeta?.alias || [],
    redirect: free_45samplew2CZcm1hUdMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsUHVBE1RDQJMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsUHVBE1RDQJMeta?.path ?? "included-products",
    meta: included_45productsUHVBE1RDQJMeta || {},
    alias: included_45productsUHVBE1RDQJMeta?.alias || [],
    redirect: included_45productsUHVBE1RDQJMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93in9TWbwDRQMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93in9TWbwDRQMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93in9TWbwDRQMeta || {},
    alias: _91media_id_93in9TWbwDRQMeta?.alias || [],
    redirect: _91media_id_93in9TWbwDRQMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewTW6CMexVdoMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewTW6CMexVdoMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewTW6CMexVdoMeta || {},
    alias: viewTW6CMexVdoMeta?.alias || [],
    redirect: viewTW6CMexVdoMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexhaX5UufEUsMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexhaX5UufEUsMeta?.path ?? "lessons",
    meta: indexhaX5UufEUsMeta || {},
    alias: indexhaX5UufEUsMeta?.alias || [],
    redirect: indexhaX5UufEUsMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93D7PuYnRycmMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93D7PuYnRycmMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93D7PuYnRycmMeta || {},
    alias: _91media_id_93D7PuYnRycmMeta?.alias || [],
    redirect: _91media_id_93D7PuYnRycmMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexei9Tw75l6hMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexei9Tw75l6hMeta?.path ?? "playlists/:playlist_id()",
    meta: indexei9Tw75l6hMeta || {},
    alias: indexei9Tw75l6hMeta?.alias || [],
    redirect: indexei9Tw75l6hMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93NIlM9NeVxeMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93NIlM9NeVxeMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93NIlM9NeVxeMeta || {},
    alias: _91media_id_93NIlM9NeVxeMeta?.alias || [],
    redirect: _91media_id_93NIlM9NeVxeMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexhEziq7fLr0Meta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexhEziq7fLr0Meta?.path ?? "playlists",
    meta: indexhEziq7fLr0Meta || {},
    alias: indexhEziq7fLr0Meta?.alias || [],
    redirect: indexhEziq7fLr0Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessions59AaQ20P1jMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessions59AaQ20P1jMeta?.path ?? "private-sessions",
    meta: private_45sessions59AaQ20P1jMeta || {},
    alias: private_45sessions59AaQ20P1jMeta?.alias || [],
    redirect: private_45sessions59AaQ20P1jMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsPUTLCFEU81Meta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingsPUTLCFEU81Meta?.path ?? "recordings",
    meta: recordingsPUTLCFEU81Meta || {},
    alias: recordingsPUTLCFEU81Meta?.alias || [],
    redirect: recordingsPUTLCFEU81Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviews6HRbzb71aIMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviews6HRbzb71aIMeta?.path ?? "reviews",
    meta: reviews6HRbzb71aIMeta || {},
    alias: reviews6HRbzb71aIMeta?.alias || [],
    redirect: reviews6HRbzb71aIMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexg1Y8aH9PuSMeta?.name ?? "buy-product-product_id",
    path: indexg1Y8aH9PuSMeta?.path ?? "/buy/product/:product_id()",
    meta: indexg1Y8aH9PuSMeta || {},
    alias: indexg1Y8aH9PuSMeta?.alias || [],
    redirect: indexg1Y8aH9PuSMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmYrTdU3cpuNMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmYrTdU3cpuNMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmYrTdU3cpuNMeta || {},
    alias: confirmYrTdU3cpuNMeta?.alias || [],
    redirect: confirmYrTdU3cpuNMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmoTSghRia5EMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmoTSghRia5EMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmoTSghRia5EMeta || {},
    alias: confirmoTSghRia5EMeta?.alias || [],
    redirect: confirmoTSghRia5EMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendarA6MXLehnsRMeta?.name ?? "calendar",
    path: calendarA6MXLehnsRMeta?.path ?? "/calendar",
    meta: calendarA6MXLehnsRMeta || {},
    alias: calendarA6MXLehnsRMeta?.alias || [],
    redirect: calendarA6MXLehnsRMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatAsLRQpXroNMeta?.name ?? "chat",
    path: chatAsLRQpXroNMeta?.path ?? "/chat",
    meta: chatAsLRQpXroNMeta || {},
    alias: chatAsLRQpXroNMeta?.alias || [],
    redirect: chatAsLRQpXroNMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93ZFG1Qt8OG9Meta?.name ?? "community-groups-group_id",
    path: _91group_id_93ZFG1Qt8OG9Meta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93ZFG1Qt8OG9Meta || {},
    alias: _91group_id_93ZFG1Qt8OG9Meta?.alias || [],
    redirect: _91group_id_93ZFG1Qt8OG9Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutCJaNPWXsz1Meta?.name ?? "community-groups-group_id-about",
    path: aboutCJaNPWXsz1Meta?.path ?? "about",
    meta: aboutCJaNPWXsz1Meta || {},
    alias: aboutCJaNPWXsz1Meta?.alias || [],
    redirect: aboutCJaNPWXsz1Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedbVKQ5MwjV2Meta?.name ?? "community-groups-group_id-feed",
    path: feedbVKQ5MwjV2Meta?.path ?? "feed",
    meta: feedbVKQ5MwjV2Meta || {},
    alias: feedbVKQ5MwjV2Meta?.alias || [],
    redirect: feedbVKQ5MwjV2Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: memberskbLFzNw0X0Meta?.name ?? "community-groups-group_id-members",
    path: memberskbLFzNw0X0Meta?.path ?? "members",
    meta: memberskbLFzNw0X0Meta || {},
    alias: memberskbLFzNw0X0Meta?.alias || [],
    redirect: memberskbLFzNw0X0Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editHQpiTco3AnMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editHQpiTco3AnMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editHQpiTco3AnMeta || {},
    alias: community_45profile_45editHQpiTco3AnMeta?.alias || [],
    redirect: community_45profile_45editHQpiTco3AnMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_939afb72Lb8dMeta?.name ?? "community-profile-id",
    path: _91id_939afb72Lb8dMeta?.path ?? "/community-profile/:id()",
    meta: _91id_939afb72Lb8dMeta || {},
    alias: _91id_939afb72Lb8dMeta?.alias || [],
    redirect: _91id_939afb72Lb8dMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communitygS5lz6Ot6RMeta?.name ?? "community",
    path: communitygS5lz6Ot6RMeta?.path ?? "/community",
    meta: communitygS5lz6Ot6RMeta || {},
    alias: communitygS5lz6Ot6RMeta?.alias || [],
    redirect: communitygS5lz6Ot6RMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_931oDdbcjk2oMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_931oDdbcjk2oMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_931oDdbcjk2oMeta || {},
    alias: _91uuid_931oDdbcjk2oMeta?.alias || [],
    redirect: _91uuid_931oDdbcjk2oMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_937tuQR6jzx8Meta?.name ?? "contracts-unique_id",
    path: _91unique_id_937tuQR6jzx8Meta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_937tuQR6jzx8Meta || {},
    alias: _91unique_id_937tuQR6jzx8Meta?.alias || [],
    redirect: _91unique_id_937tuQR6jzx8Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardnjagcio01FMeta?.name ?? "dashboard",
    path: dashboardnjagcio01FMeta?.path ?? "/dashboard",
    meta: dashboardnjagcio01FMeta || {},
    alias: dashboardnjagcio01FMeta?.alias || [],
    redirect: dashboardnjagcio01FMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexmai1kWu4eJMeta?.name ?? "event-details-event_id",
    path: indexmai1kWu4eJMeta?.path ?? "/event/details/:event_id()",
    meta: indexmai1kWu4eJMeta || {},
    alias: indexmai1kWu4eJMeta?.alias || [],
    redirect: indexmai1kWu4eJMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutJbUyiao4LCMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutJbUyiao4LCMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutJbUyiao4LCMeta || {},
    alias: checkoutJbUyiao4LCMeta?.alias || [],
    redirect: checkoutJbUyiao4LCMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productzx86FhBeGoMeta?.name ?? "event-details-event_id-select-product",
    path: select_45productzx86FhBeGoMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productzx86FhBeGoMeta || {},
    alias: select_45productzx86FhBeGoMeta?.alias || [],
    redirect: select_45productzx86FhBeGoMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: events3hL2MadiOtMeta?.name ?? "events",
    path: events3hL2MadiOtMeta?.path ?? "/events",
    meta: events3hL2MadiOtMeta || {},
    alias: events3hL2MadiOtMeta?.alias || [],
    redirect: events3hL2MadiOtMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93RNf9cruDbRMeta?.name ?? "gifts-uuid",
    path: _91uuid_93RNf9cruDbRMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93RNf9cruDbRMeta || {},
    alias: _91uuid_93RNf9cruDbRMeta?.alias || [],
    redirect: _91uuid_93RNf9cruDbRMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexCt7lwsFixBMeta?.name ?? "gifts",
    path: indexCt7lwsFixBMeta?.path ?? "/gifts",
    meta: indexCt7lwsFixBMeta || {},
    alias: indexCt7lwsFixBMeta?.alias || [],
    redirect: indexCt7lwsFixBMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93CJSNgVsMl8Meta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93CJSNgVsMl8Meta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93CJSNgVsMl8Meta || {},
    alias: _91invitation_id_93CJSNgVsMl8Meta?.alias || [],
    redirect: _91invitation_id_93CJSNgVsMl8Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93jHVJRgPTuRMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93jHVJRgPTuRMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93jHVJRgPTuRMeta || {},
    alias: _91product_id_93jHVJRgPTuRMeta?.alias || [],
    redirect: _91product_id_93jHVJRgPTuRMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexfjL8mtvdtxMeta?.name ?? "index",
    path: indexfjL8mtvdtxMeta?.path ?? "/",
    meta: indexfjL8mtvdtxMeta || {},
    alias: indexfjL8mtvdtxMeta?.alias || [],
    redirect: indexfjL8mtvdtxMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93yuzIVc3Dv5Meta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93yuzIVc3Dv5Meta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93yuzIVc3Dv5Meta || {},
    alias: _91invitation_unique_id_93yuzIVc3Dv5Meta?.alias || [],
    redirect: _91invitation_unique_id_93yuzIVc3Dv5Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joinS56979vcSEMeta?.name ?? "join",
    path: joinS56979vcSEMeta?.path ?? "/join",
    meta: joinS56979vcSEMeta || {},
    alias: joinS56979vcSEMeta?.alias || [],
    redirect: joinS56979vcSEMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginpavzGGn8QtMeta?.name ?? "login",
    path: loginpavzGGn8QtMeta?.path ?? "/login",
    meta: loginpavzGGn8QtMeta || {},
    alias: loginpavzGGn8QtMeta?.alias || [],
    redirect: loginpavzGGn8QtMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutQjqeolaskMMeta?.name ?? "logout",
    path: logoutQjqeolaskMMeta?.path ?? "/logout",
    meta: logoutQjqeolaskMMeta || {},
    alias: logoutQjqeolaskMMeta?.alias || [],
    redirect: logoutQjqeolaskMMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93S4AQtSjIj2Meta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93S4AQtSjIj2Meta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93S4AQtSjIj2Meta || {},
    alias: _91meeting_type_slug_93S4AQtSjIj2Meta?.alias || [],
    redirect: _91meeting_type_slug_93S4AQtSjIj2Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93qqNIY1laGlMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93qqNIY1laGlMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93qqNIY1laGlMeta || {},
    alias: _91meeting_unique_id_93qqNIY1laGlMeta?.alias || [],
    redirect: _91meeting_unique_id_93qqNIY1laGlMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93feQKDfwAdbMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93feQKDfwAdbMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93feQKDfwAdbMeta || {},
    alias: _91meeting_unique_id_93feQKDfwAdbMeta?.alias || [],
    redirect: _91meeting_unique_id_93feQKDfwAdbMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritesMBJGhFVGGQMeta?.name ?? "my-favorites",
    path: my_45favoritesMBJGhFVGGQMeta?.path ?? "/my-favorites",
    meta: my_45favoritesMBJGhFVGGQMeta || {},
    alias: my_45favoritesMBJGhFVGGQMeta?.alias || [],
    redirect: my_45favoritesMBJGhFVGGQMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studioslGnlSkOp89Meta?.name ?? "my-studios",
    path: my_45studioslGnlSkOp89Meta?.path ?? "/my-studios",
    meta: my_45studioslGnlSkOp89Meta || {},
    alias: my_45studioslGnlSkOp89Meta?.alias || [],
    redirect: my_45studioslGnlSkOp89Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optinSnrO9npU0FMeta?.name ?? "optin",
    path: optinSnrO9npU0FMeta?.path ?? "/optin",
    meta: optinSnrO9npU0FMeta || {},
    alias: optinSnrO9npU0FMeta?.alias || [],
    redirect: optinSnrO9npU0FMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93srktvtmQsxMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93srktvtmQsxMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93srktvtmQsxMeta || {},
    alias: _91episode_id_93srktvtmQsxMeta?.alias || [],
    redirect: _91episode_id_93srktvtmQsxMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexTXFlIxJ3z0Meta?.name ?? "podcasts-podcast_id",
    path: indexTXFlIxJ3z0Meta?.path ?? "/podcasts/:podcast_id()",
    meta: indexTXFlIxJ3z0Meta || {},
    alias: indexTXFlIxJ3z0Meta?.alias || [],
    redirect: indexTXFlIxJ3z0Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexdCGjrBCGImMeta?.name ?? "podcasts",
    path: indexdCGjrBCGImMeta?.path ?? "/podcasts",
    meta: indexdCGjrBCGImMeta || {},
    alias: indexdCGjrBCGImMeta?.alias || [],
    redirect: indexdCGjrBCGImMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93q58ssjBRktMeta?.name ?? "product-product_id",
    path: _91product_id_93q58ssjBRktMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_93q58ssjBRktMeta || {},
    alias: _91product_id_93q58ssjBRktMeta?.alias || [],
    redirect: _91product_id_93q58ssjBRktMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutnd3OxzOXM7Meta?.name ?? "product-product_id-about",
    path: aboutnd3OxzOXM7Meta?.path ?? "about",
    meta: aboutnd3OxzOXM7Meta || {},
    alias: aboutnd3OxzOXM7Meta?.alias || [],
    redirect: aboutnd3OxzOXM7Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45content7k6XXyiowRMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45content7k6XXyiowRMeta?.path ?? "digital-download-content",
    meta: digital_45download_45content7k6XXyiowRMeta || {},
    alias: digital_45download_45content7k6XXyiowRMeta?.alias || [],
    redirect: digital_45download_45content7k6XXyiowRMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventsSFd9RUvdrCMeta?.name ?? "product-product_id-events",
    path: eventsSFd9RUvdrCMeta?.path ?? "events",
    meta: eventsSFd9RUvdrCMeta || {},
    alias: eventsSFd9RUvdrCMeta?.alias || [],
    redirect: eventsSFd9RUvdrCMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93h5aRYzxtDqMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93h5aRYzxtDqMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93h5aRYzxtDqMeta || {},
    alias: _91media_id_93h5aRYzxtDqMeta?.alias || [],
    redirect: _91media_id_93h5aRYzxtDqMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleKEWsEF8pt8Meta?.name ?? "product-product_id-free-sample",
    path: free_45sampleKEWsEF8pt8Meta?.path ?? "free-sample",
    meta: free_45sampleKEWsEF8pt8Meta || {},
    alias: free_45sampleKEWsEF8pt8Meta?.alias || [],
    redirect: free_45sampleKEWsEF8pt8Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsCSVXxvVHAqMeta?.name ?? "product-product_id-included-products",
    path: included_45productsCSVXxvVHAqMeta?.path ?? "included-products",
    meta: included_45productsCSVXxvVHAqMeta || {},
    alias: included_45productsCSVXxvVHAqMeta?.alias || [],
    redirect: included_45productsCSVXxvVHAqMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93JiAjxQMegHMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93JiAjxQMegHMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93JiAjxQMegHMeta || {},
    alias: _91media_id_93JiAjxQMegHMeta?.alias || [],
    redirect: _91media_id_93JiAjxQMegHMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: view2mftcnPqczMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: view2mftcnPqczMeta?.path ?? "lessons/:lesson_id()/view",
    meta: view2mftcnPqczMeta || {},
    alias: view2mftcnPqczMeta?.alias || [],
    redirect: view2mftcnPqczMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexgQYCSRRFlvMeta?.name ?? "product-product_id-lessons",
    path: indexgQYCSRRFlvMeta?.path ?? "lessons",
    meta: indexgQYCSRRFlvMeta || {},
    alias: indexgQYCSRRFlvMeta?.alias || [],
    redirect: indexgQYCSRRFlvMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93sQXGljHVVsMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93sQXGljHVVsMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93sQXGljHVVsMeta || {},
    alias: _91media_id_93sQXGljHVVsMeta?.alias || [],
    redirect: _91media_id_93sQXGljHVVsMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexUGh8LkVziPMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexUGh8LkVziPMeta?.path ?? "playlists/:playlist_id()",
    meta: indexUGh8LkVziPMeta || {},
    alias: indexUGh8LkVziPMeta?.alias || [],
    redirect: indexUGh8LkVziPMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_930ZaYMrX34DMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_930ZaYMrX34DMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_930ZaYMrX34DMeta || {},
    alias: _91media_id_930ZaYMrX34DMeta?.alias || [],
    redirect: _91media_id_930ZaYMrX34DMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexIcUkSj0v76Meta?.name ?? "product-product_id-playlists",
    path: indexIcUkSj0v76Meta?.path ?? "playlists",
    meta: indexIcUkSj0v76Meta || {},
    alias: indexIcUkSj0v76Meta?.alias || [],
    redirect: indexIcUkSj0v76Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsHnCpSnWkrNMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsHnCpSnWkrNMeta?.path ?? "private-sessions",
    meta: private_45sessionsHnCpSnWkrNMeta || {},
    alias: private_45sessionsHnCpSnWkrNMeta?.alias || [],
    redirect: private_45sessionsHnCpSnWkrNMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordings3kCq0S3LmUMeta?.name ?? "product-product_id-recordings",
    path: recordings3kCq0S3LmUMeta?.path ?? "recordings",
    meta: recordings3kCq0S3LmUMeta || {},
    alias: recordings3kCq0S3LmUMeta?.alias || [],
    redirect: recordings3kCq0S3LmUMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviews8UioZpvnvKMeta?.name ?? "product-product_id-reviews",
    path: reviews8UioZpvnvKMeta?.path ?? "reviews",
    meta: reviews8UioZpvnvKMeta || {},
    alias: reviews8UioZpvnvKMeta?.alias || [],
    redirect: reviews8UioZpvnvKMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexSYGbTfmfq9Meta?.name ?? "product",
    path: indexSYGbTfmfq9Meta?.path ?? "/product",
    meta: indexSYGbTfmfq9Meta || {},
    alias: indexSYGbTfmfq9Meta?.alias || [],
    redirect: indexSYGbTfmfq9Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexKPgeOMVDS8Meta?.name ?? "profile",
    path: indexKPgeOMVDS8Meta?.path ?? "/profile",
    meta: indexKPgeOMVDS8Meta || {},
    alias: indexKPgeOMVDS8Meta?.alias || [],
    redirect: indexKPgeOMVDS8Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesySrdx84TG9Meta?.name ?? "profile-purchases",
    path: purchasesySrdx84TG9Meta?.path ?? "/profile/purchases",
    meta: purchasesySrdx84TG9Meta || {},
    alias: purchasesySrdx84TG9Meta?.alias || [],
    redirect: purchasesySrdx84TG9Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionszEypn95vAhMeta?.name ?? "profile-redemptions",
    path: redemptionszEypn95vAhMeta?.path ?? "/profile/redemptions",
    meta: redemptionszEypn95vAhMeta || {},
    alias: redemptionszEypn95vAhMeta?.alias || [],
    redirect: redemptionszEypn95vAhMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93u1FfGtOJjzMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93u1FfGtOJjzMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93u1FfGtOJjzMeta || {},
    alias: _91quiz_id_93u1FfGtOJjzMeta?.alias || [],
    redirect: _91quiz_id_93u1FfGtOJjzMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93ey6SdqgybsMeta?.name ?? "reset-password-uid-token",
    path: _91token_93ey6SdqgybsMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93ey6SdqgybsMeta || {},
    alias: _91token_93ey6SdqgybsMeta?.alias || [],
    redirect: _91token_93ey6SdqgybsMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: reset5SwQMMVUGcMeta?.name ?? "reset",
    path: reset5SwQMMVUGcMeta?.path ?? "/reset",
    meta: reset5SwQMMVUGcMeta || {},
    alias: reset5SwQMMVUGcMeta?.alias || [],
    redirect: reset5SwQMMVUGcMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopWs1cHNNRBVMeta?.name ?? "shop",
    path: shopWs1cHNNRBVMeta?.path ?? "/shop",
    meta: shopWs1cHNNRBVMeta || {},
    alias: shopWs1cHNNRBVMeta?.alias || [],
    redirect: shopWs1cHNNRBVMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupah9zGhp6XpMeta?.name ?? "signup",
    path: signupah9zGhp6XpMeta?.path ?? "/signup",
    meta: signupah9zGhp6XpMeta || {},
    alias: signupah9zGhp6XpMeta?.alias || [],
    redirect: signupah9zGhp6XpMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: liveRn7aMKLqREMeta?.name ?? "streaming-event_id-live",
    path: liveRn7aMKLqREMeta?.path ?? "/streaming/:event_id()/live",
    meta: liveRn7aMKLqREMeta || {},
    alias: liveRn7aMKLqREMeta?.alias || [],
    redirect: liveRn7aMKLqREMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsjVWhOpaDuPMeta?.name ?? "tips",
    path: tipsjVWhOpaDuPMeta?.path ?? "/tips",
    meta: tipsjVWhOpaDuPMeta || {},
    alias: tipsjVWhOpaDuPMeta?.alias || [],
    redirect: tipsjVWhOpaDuPMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93NetqkK5zd2Meta?.name ?? "waiver-uuid",
    path: _91uuid_93NetqkK5zd2Meta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93NetqkK5zd2Meta || {},
    alias: _91uuid_93NetqkK5zd2Meta?.alias || [],
    redirect: _91uuid_93NetqkK5zd2Meta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compact0F26Z4QgksMeta?.name ?? "widgets-calendars-compact",
    path: compact0F26Z4QgksMeta?.path ?? "/widgets/calendars/compact",
    meta: compact0F26Z4QgksMeta || {},
    alias: compact0F26Z4QgksMeta?.alias || [],
    redirect: compact0F26Z4QgksMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: fulllUvYc5kRCWMeta?.name ?? "widgets-calendars-full",
    path: fulllUvYc5kRCWMeta?.path ?? "/widgets/calendars/full",
    meta: fulllUvYc5kRCWMeta || {},
    alias: fulllUvYc5kRCWMeta?.alias || [],
    redirect: fulllUvYc5kRCWMeta?.redirect,
    component: () => import("/tmp/build_3027f3f6/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]